import { render, staticRenderFns } from "./ConsultationScriptForm.vue?vue&type=template&id=2bcd6ce0&scoped=true&lang=pug"
import script from "./ConsultationScriptForm.vue?vue&type=script&lang=js"
export * from "./ConsultationScriptForm.vue?vue&type=script&lang=js"
import style0 from "./ConsultationScriptForm.vue?vue&type=style&index=0&id=2bcd6ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bcd6ce0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Spinner: require('/home/docker/code/frontend/components/Spinner.vue').default,ClientSelect: require('/home/docker/code/frontend/components/ClientSelect.vue').default,Editor: require('/home/docker/code/frontend/components/Editor.vue').default})
